export const dineInMenuData = {
  indiskaForratter: [
    {
      number: "1",
      name: "Papadam",
      description: "2 st krispiga linsbröd. Serveras med mango chutney.",
      price: "55",
      allergens: "Mild chili"
    },
    {
      number: "2",
      name: "Vegetable Samosa",
      description: "2 st indiska grönsakspiroger. Serveras med sallad och myntasås.",
      price: "69",
      allergens: "Gluten, Mejeriprodukter, Medium chili"
    },
    {
      number: "3",
      name: "Onion Bhaji",
      description: "Välkryddad friterad lök. Serveras med myntasås.",
      price: "69",
      allergens: "Medium chili"
    },
    {
      number: "4",
      name: "Indiska Vårrullar",
      description: "3 st vårrullar fyllda med kryddad kycklingfärs. Serveras friterade med myntasås.",
      price: "79",
      allergens: "Gluten, Mejeriprodukter, Medium chili"
    },
    {
      number: "5",
      name: "Kyckling Seekh Kebab",
      description: "2 st stekta kycklingkebab. Serveras med sallad och imli chutney.",
      price: "99",
      allergens: "Gluten, Mejeriprodukter, Medium chili"
    },
    {
      number: "100",
      name: "Chicken Kathi Roll",
      description: "Grillad kyckling rullas in i paratha med sallad och sås. Serveras med hari chutney.",
      price: "89",
      allergens: "Gluten, Mejeriprodukter, Medium chili"
    },
    {
      number: "102",
      name: "Pani Puri",
      description: "6 st små, krispiga bollar (puris) som är fyllda med en kryddig blandning av potatis, kikärtor och olika kryddor. Serveras med tamarind-, mynta- och koriandervatten.",
      price: "75",
      allergens: "Gluten, Mejeriprodukter, Medium chili"
    },
    {
      number: "104",
      name: "Mix Fusion Thali",
      description: "1 st chicken roll, 2 st samosa, 2 st seekh Kebab. Serveras med imli chutney, myntasås och sallad.",
      price: "199",
      allergens: "Gluten, Mejeriprodukter, Medium chili"
    }
  ],
  kockensRekommendation: [
    {
      number: "6",
      name: "Chicken Tikka Masala",
      description: "Kyckling grillad och tillagas med yoghurt, indiska kryddor, mandel, kokos och grädde. Kan inte serveras utan nötter.",
      price: "159",
      allergens: "Nötter, Mejeriprodukter, Mild chili"
    },
    {
      number: "7",
      name: "Hot Chili Chicken",
      description: "Grillad kyckling med chili, lök, paprika, socker, masalasås och sweet chilisås.",
      price: "169",
      allergens: "Mejeriprodukter, Stark chili"
    },
    {
      number: "8",
      name: "Garlic Chicken Tikka Masala",
      description: "Vitlöksmarinerad kyckling tillagas med yogurt, kryddor, mandel, kokos, socker och grädde. Kan inte serveras utan nötter.",
      price: "169",
      allergens: "Nötter, Mejeri, Mild chili"
    },
    {
      number: "9",
      name: "Korma",
      description: "Tillagas i en sås med grädde, svartpeppar, socker, smör kokos och mandel.",
      variants: "Kyckling 169kr | Räkor 199kr | Lamm 199kr",
      price: "169",
      allergens: "Nötter, Mejeriprodukter, Mild chili"
    },
    {
      number: "10",
      name: "Tandoori Chicken Moglai Rezala",
      description: "Grillad kyckling med lök, grädde, yoghurt, socker och kryddor.",
      price: "169",
      allergens: "Mejeriprodukter, Medium chili"
    },
    {
      number: "11",
      name: "Bhuna",
      description: "Gryta tillagad med lök, tomat, paprika.",
      variants: "Kyckling 169kr | Biff 179kr | Lamm 199kr",
      price: "169",
      allergens: "Medium chili"
    },
    {
      number: "12",
      name: "Jalfrezi",
      description: "Stark gryta med lök, tomat, paprika och färsk chili.",
      variants: "Kyckling 169kr | Biff 179kr | Lamm 199kr",
      price: "169",
      allergens: "Stark chili"
    },
    {
      number: "13",
      name: "Madras",
      description: "Sydindisk rätt med stark madrassås, tomat sås och citron.",
      variants: "Kyckling 169kr | Biff 179kr | Lamm 199kr",
      price: "169",
      allergens: "Stark chili"
    },
    {
      number: "14",
      name: "Vindaloo",
      description: "Rätt med potatis tillagad i en extra het vindaloosås.",
      variants: "Kyckling 169kr | Biff 179kr | Lamm 199kr",
      price: "169",
      allergens: "Extra stark chili"
    },
    {
      number: "15",
      name: "Karai",
      description: "Gryta tillagad med tomater, lök, paprika och kryddor.",
      variants: "Kyckling 169kr | Lamm 199kr | Räkor 199kr",
      price: "169",
      allergens: "Medium chili"
    },
    {
      number: "16",
      name: "Saagwala",
      description: "Tillagad med spenat, grädde, ingefära, vitlök, lök och paprika.",
      variants: "Kyckling 169kr | Biff 179kr | Lamm 199kr",
      price: "169",
      allergens: "Mejeriprodukter, Medium chili"
    },
    {
      number: "17",
      name: "Bombay Masala",
      description: "Tillagad med traditionell sås, lök, paprika, tamarind och frukt.",
      variants: "Grill kyckling 169kr | Räkor 199kr",
      price: "169",
      allergens: "Mejeriprodukter, Medium chili"
    },
    {
      number: "18",
      name: "Butter Chicken Tikka",
      description: "Mör kyckling marinerad i yoghurt och kryddor, tillagad i en rik och krämig tomatsås, ingefära, grön chili, grädde, cashewnötter smör och socker. Kan inte serveras utan cashew och chili.",
      price: "169",
      allergens: "Nötter, Mejeriprodukter, Medium chili"
    },
    {
      number: "19",
      name: "Lamm Rogan Josh",
      description: "Lamm med tomat, lök, paprika, ingefära, kryddor och lök sås.",
      price: "199",
      allergens: "Mejeriprodukter, Medium chili"
    },
    {
      number: "66",
      name: "Shahi Qorma (Autentisk rätt)",
      description: "Kyckling (med ben) tillagad i krämig sås med tomat, grädde, och en blandning av aromatiska kryddor. Serveras med naan bröd.",
      price: "199",
      allergens: "Mejeriprodukter, Stark chili"
    },
    {
      number: "67",
      name: "Biryani (Autentisk rätt)",
      description: "Kryddat ris tillagat med tomat sås, yoghurt, garam masala och grönsaker. Serveras med raita.",
      variants: "Grönsaker 169 | Räkor 179 | Kyckling lår 199kr",
      price: "169",
      allergens: "Mejeriprodukter, Stark chili"
    },
    {
      number: "121",
      name: "Achari Handi",
      description: "Tillagad med pickles, yoghurt, lök sås, kryddor och koriander.",
      variants: "Kyckling 169kr | Biff 179kr | Lamm 199kr",
      price: "169",
      allergens: "Mejeriprodukter, Stark chili"
    }
  ],
  balti: [
    {
      number: "20",
      name: "King Prawn",
      description: "Stora räkor i baltisås med vitlök, lök, paprika, mandel, färsk koriander och tomat.",
      price: "179",
      allergens: "Nötter, Mejeriprodukter, Medium chili"
    },
    {
      number: "21",
      name: "Chicken Tikka",
      description: "Grillad kyckling i baltisås med vitlök, lök, paprika, mandel, färsk koriander och tomat.",
      price: "179",
      allergens: "Nötter, Mejeriprodukter, Medium chili"
    },
    {
      number: "22",
      name: "Chicken Tikka Garlic Balti",
      description: "Vitlöksmarinerad Grillad kyckling i baltisås med vitlök, mandel lök, paprika, färsk koriander och tomat.",
      price: "179",
      allergens: "Nötter, Mejeriprodukter, Medium chili"
    }
  ],
  tandooriGrillat: [
    {
      number: "23",
      name: "Tandoori Chicken Sizzler",
      description: "Marinerat kycklinglår grillad i tandooriugn.",
      price: "179",
      allergens: "Mejeriprodukter, Medium chili"
    },
    {
      number: "24",
      name: "Chicken Tikka Sizzler",
      description: "Marinerat kycklingfilébitar grillad i tandooriugn.",
      price: "189",
      allergens: "Mejeriprodukter, Medium chili"
    },
    {
      number: "25",
      name: "Garlic Chicken Tikka Sizzler",
      description: "Vitlöksmarinerade kycklingfilébitar grillad i tandooriugn.",
      price: "189",
      allergens: "Mejeriprodukter, Medium chili"
    },
    {
      number: "26",
      name: "Mix Sizzler",
      description: "Marinerat och grillad kycklingfilé, vitlökskycklingfilé och jätterräkor.",
      price: "219",
      allergens: "Mejeriprodukter, Medium chili"
    }
  ],
  vegetariskt: [
    {
      number: "28",
      name: "Paneer Mango Masala",
      description: "Halloumiost tillagad med mango, mandel, kokos och grädde i en mild sås. Kan inte serveras utan nötter.",
      price: "169",
      allergens: "Nötter, Mejeriprodukter, Mild chili"
    },
    {
      number: "29",
      name: "Mix Vegetable Curry",
      description: "Säsongens grönsaker tillagas med medelhet currysås och tomatsås.",
      price: "179",
      allergens: "Mejeriprodukter, Medium chili"
    },
    {
      number: "30",
      name: "Tarka Daal",
      description: "Stekta linser tillagada med tomat, vitlök, smör och koriander.",
      price: "179",
      allergens: "Mejeriprodukter, Medium chili"
    },
    {
      number: "31",
      name: "Palak Paneer",
      description: "Spenat och Halloumiost tillagade med vitlök, lök, och paprika.",
      price: "169",
      allergens: "Mejeriprodukter, Medium chili"
    },
    {
      number: "131",
      name: "Chana Saag",
      description: "Indiska kikärtor tillagade med spenat, tomat, lök, grädde, smör, koriander och indisk curry.",
      price: "159",
      allergens: "Mejeriprodukter, Medium chili"
    },
    {
      number: "132",
      name: "Paneer Tikka Karai",
      description: "Färskost tillagad med tomat, lök, paprika och indisk curry.",
      price: "169",
      allergens: "Mejeriprodukter, Medium chili"
    },
    {
      number: "133",
      name: "Chana Masala",
      description: "Kikärtor tillagda i en kryddig sås med ingredienser som tomat, lök, vitlök, ingefära och olika kryddor som garam masala, spiskummin och koriander.",
      price: "159",
      allergens: "Mejeriprodukter, Medium chili"
    },
    {
      number: "134",
      name: "Tofu Dopiaza",
      description: "Tofu gryta tillagad med tomater, lök, paprika och kryddor.",
      price: "169",
      allergens: "Mejeriprodukter, Medium chili"
    }
  ],
  naan: [
    {
      number: "32",
      name: "Paratha",
      description: "Indiskt bröd stekt i smör, med en krispig yta och mjuk insida.",
      price: "35",
      allergens: "Gluten, Mejeriprodukter"
    },
    {
      number: "33",
      name: "Plain Naan",
      description: "Ett mjukt och luftigt indiskt plattbröd serverat med smör.",
      price: "35",
      allergens: "Gluten, Mejeriprodukter"
    },
    {
      number: "34",
      name: "Garlic Naan",
      description: "En smakrik variant av det traditionella indiska naanbrödet, kryddat med vitlök och smör för en extra smakupplevelse.",
      price: "40",
      allergens: "Gluten, Mejeriprodukter"
    },
    {
      number: "35",
      name: "Moglai Naan",
      description: "En lyxig variant av det traditionella indiska naanbrödet, fyllt med almond, kokos, socker och smör.",
      price: "40",
      allergens: "Mejeriprodukter, Nötter, Gluten"
    },
    {
      number: "36",
      name: "Paneer Naan",
      description: "Ett indiskt bröd fyllt med smulad ost.",
      price: "40",
      allergens: "Gluten, Mejeriprodukter"
    },
    {
      number: "141",
      name: "Masala Naan",
      description: "En smakrik variant av det traditionella indiska naanbrödet, kryddat med vitlök, lök och koriander för en extra smakupplevelse.",
      price: "45",
      allergens: "Gluten, Mejeriprodukter"
    },
    {
      number: "142",
      name: "Tandoori Roti",
      description: "Tandoori roti är ett indiskt plattbröd som gräddas i en tandoor.",
      price: "19",
      allergens: "Mejeriprodukter, Gluten"
    }
  ],
  indiskaTillbehor: [
    {
      number: "37",
      name: "Raita",
      description: "Raita yoghurtdipp som innehåller kryddor, socker, gurka och tomat.",
      price: "30",
      allergens: "Mejeriprodukter"
    },
    {
      number: "38",
      name: "Pickles",
      description: "Inlagda grönsaker eller frukter konserverade i vinäger, salt, socker och kryddor.",
      price: "25",
      allergens: "Stark chili"
    },
    {
      number: "39",
      name: "Mango Chutney",
      description: "En indisk sås gjord av mogna mangofrukter, socker, vinäger och kryddor.",
      price: "25",
      allergens: "Mild chili"
    },
    {
      number: "40",
      name: "Myntasås",
      description: "En fräsch sås gjord av färsk mynta, vinäger, socker och youghurt.",
      price: "25",
      allergens: "Mejeriprodukter"
    },
    {
      number: "41",
      name: "Naturell Yoghurt",
      description: "Krämig och osötad youghurt gjord av fermenterad mjölk.",
      price: "20",
      allergens: "Mejeriprodukter"
    },
    {
      number: "42",
      name: "Extra Ris",
      description: "Liten 29kr | Stor 49kr",
      price: "29",
      allergens: ""
    }
  ],
  thaiForratter: [
    {
      number: "1",
      name: "Grönsaksvårrullar (Pho pia phak)",
      description: "10 st. vårrullar fyllda med en mix av härliga grönsaker. Serveras med sallad och en smakfull sweet chili dippsås.",
      price: "89",
      allergens: "Gluten"
    },
    {
      number: "2",
      name: "Biffvårrullar (Pho pia neua)",
      description: "3 st vårrullar fyllda med saftigt biffkött och smakrika ingredienser. Serveras med sallad och sweet chili dippsås.",
      price: "99",
      allergens: "Gluten"
    },
    {
      number: "3",
      name: "Krispiga Räkor (Goong thod)",
      description: "10 st. friterade räkor Serveras med sallad och sweet chili dippsås.",
      price: "129",
      allergens: "Gluten"
    },
    {
      number: "4",
      name: "Mixad Friterad Tallrik",
      description: "Innehåller 4 st vegetariska vårrullar, 2 st köttfärsfyllda vårrullar, 4 st friterade räkor, sallad och 2 såser.",
      price: "139",
      allergens: "Gluten"
    },
    {
      number: "5",
      name: "Knaper Kyckling (Gai thod)",
      description: "4 - 5 st. kycklingfilé, marinerad och panerad i panko. Serveras lätt friterad med sötsur sås och sallad.",
      price: "129",
      allergens: "Gluten"
    },
    {
      number: "6",
      name: "Kyckling-Satay Spett (Satay gai)",
      description: "4 st. äkta thailändska kycklingspett med härligt god hemgjord jordnötssås. Serveras friterad med sallad.",
      price: "139",
      allergens: "Gluten, Nötter"
    }
  ],
  thaiHuvratter: [
    {
      number: "21",
      name: "Curry Fusion",
      description: "Tillagad med husets kryddiga panängsås tillsammans med kokosmjölk, grönsaker och kryddor.",
      variants: "Kyckling 139kr | Biff 149kr | Räkor 159kr",
      price: "139",
      allergens: "Gluten, Medium chili"
    },
    {
      number: "22",
      name: "Cashew Wok",
      description: "Tillagad med cashewnötter och grönsaker i en smakrik woksås.",
      variants: "Kyckling 139kr | Biff 149kr | Räkor 159kr",
      price: "139",
      allergens: "Gluten, Nötter, Medium chili"
    },
    {
      number: "23",
      name: "Sommar Wok",
      description: "Wokad tillsammans med vitlök, ägg, kryddor, grönsaker, woksås och äggnudlar.",
      variants: "Kyckling 139kr | Biff 149kr | Räkor 159kr",
      price: "139",
      allergens: "Gluten, Medium chili"
    },
    {
      number: "24",
      name: "Lime Wok",
      description: "Wokad tillsammans med vitlök, ägg, lime, kryddor, grönsaker och risnudlar (breda).",
      variants: "Kyckling 139kr | Biff 149kr | Räkor 159kr",
      price: "139",
      allergens: "Gluten, Medium chili"
    },
    {
      number: "25",
      name: "Risnudel Wok",
      description: "Wokad tillsammans med ägg, vitlök, tamarindsås, kryddor, grönsaker, risnudlar, jordnötter och böngroddar.",
      variants: "Kyckling 139kr | Biff 149kr | Räkor 159kr",
      price: "139",
      allergens: "Gluten, Nötter, Medium chili"
    },
    {
      number: "26",
      name: "Stekt Ris",
      description: "Klassisk rätt stekt med ris, vitlök, ägg och grönsaker.",
      variants: "Kyckling 139kr | Biff 149kr | Räkor 159kr",
      price: "139",
      allergens: "Gluten, Medium chili"
    },
    {
      number: "27",
      name: "Ananas Stekt Ris",
      description: "Klassisk rätt stekt med ananas, ris, vitlök, ägg och grönsaker.",
      variants: "Kyckling 149kr | Biff 159kr | Räkor 169kr",
      price: "149",
      allergens: "Gluten, Medium chili"
    },
    {
      number: "28",
      name: "Green Curry",
      description: "Tillagad med husets kryddiga grönsås tillsammans med kokosmjölk, grönsaker och kryddor.",
      variants: "Kyckling 149kr | Biff 159kr | Räkor 169kr",
      price: "149",
      allergens: "Gluten, Stark chili"
    },
    {
      number: "29",
      name: "Krispiga Ankbröst",
      description: "Friterat ankbröst. Serveras med vitlök och grönsakaswok.",
      price: "169",
      allergens: "Gluten, Medium chili"
    }
  ],
  sushiHosomaki: [
    {
      number: "1",
      name: "Avokado",
      description: "Ris och avokado, elegant inlindade i sjögräs.",
      price: "75",
      allergens: ""
    },
    {
      number: "2",
      name: "Gurka",
      description: "Ris och gurka, elegant inlindade i sjögräs.",
      price: "75",
      allergens: ""
    },
    {
      number: "3",
      name: "Mango",
      description: "Ris och mango, elegant inlindade i sjögräs.",
      price: "75",
      allergens: ""
    },
    {
      number: "4",
      name: "Lax",
      description: "Ris och lax, elegant inlindade i sjögräs.",
      price: "85",
      allergens: ""
    }
  ],
  sushiUramaki: [
    {
      number: "11",
      name: "California Maki",
      description: "Handskalade räkor, avokado och gurka, toppade med sesam.",
      price: "139",
      allergens: ""
    },
    {
      number: "12",
      name: "Tempura Maki",
      description: "Friterade räkor, toppade med chilimajonnäs, unagi-sås och rostad lök.",
      price: "139",
      allergens: ""
    },
    {
      number: "13",
      name: "Deluxe Tempura Maki",
      description: "Friterade räkor, toppade med flamberad lax, chilimajonnäs, unagi-sås och gräslök.",
      price: "149",
      allergens: ""
    },
    {
      number: "14",
      name: "Lax Maki",
      description: "Lax, gurka och avokado, toppade med sesam.",
      price: "139",
      allergens: ""
    },
    {
      number: "15",
      name: "Deluxe Lax Maki",
      description: "Lax och avokado, toppade med flamberad lax, chilimajonnäs, unagi-sås och gräslök.",
      price: "149",
      allergens: ""
    },
    {
      number: "16",
      name: "Tartar Maki",
      description: "Lax, olivolja, sesamolja, Siracha och gurka, toppade med tobiko.",
      price: "139",
      allergens: ""
    },
    {
      number: "17",
      name: "Kyckling Maki",
      description: "Friterad kyckling, toppade med chilimajonnäs, unagi-sås och rostad lök.",
      price: "139",
      allergens: ""
    },
    {
      number: "18",
      name: "Deluxe Kyckling Maki",
      description: "Friterad kyckling, toppade med avokado, chilimajonnäs, unagi-sås och gräslök.",
      price: "149",
      allergens: ""
    }
  ],
  sushiNigiri: [
    {
      number: "31",
      name: "Avokado",
      description: "En liten, avlång boll av vinägerat sushiris, toppad med wasabi skivor av avokado, chilimajo och rostad lök.",
      price: "35",
      allergens: ""
    },
    {
      number: "32",
      name: "Räkor",
      description: "En liten, avlång boll av vinägerat sushiris, toppad med wasabi, räkor, chilimajo och gräslök.",
      price: "39",
      allergens: ""
    },
    {
      number: "33",
      name: "Lax",
      description: "En liten, avlång boll av vinägerat sushiris, toppad med wasabi, skivor av lax, chilimajo, unagi-sås och sesam.",
      price: "39",
      allergens: ""
    },
    {
      number: "34",
      name: "Deluxe Lax",
      description: "En liten, avlång boll av vinägerat sushiris, toppad med flamberad lax och tobiko.",
      price: "49",
      allergens: ""
    },
    {
      number: "35",
      name: "Sushi Bomb",
      description: "Risboll omsluts varsamt av delikata bitar av avokado, gurka, lax och mango maki. Toppad med chilimajo, unagi-sås och roastad lök.",
      price: "75",
      allergens: ""
    }
  ],
  sushiTillbehor: [
    {
      number: "",
      name: "Chilimajo",
      description: "",
      price: "15",
      allergens: ""
    },
    {
      number: "",
      name: "Sojasås",
      description: "",
      price: "15",
      allergens: ""
    },
    {
      number: "",
      name: "Unagisås",
      description: "",
      price: "15",
      allergens: ""
    },
    {
      number: "",
      name: "Wakami",
      description: "",
      price: "15",
      allergens: ""
    },
    {
      number: "",
      name: "Ingefära",
      description: "",
      price: "15",
      allergens: ""
    }
  ],
  barnmeny: [
    {
      number: "43",
      name: "Chicken Tikka Masala",
      description: "Kyckling grillad och tillagad med yoghurt, indiska kryddor, mandel, kokos och grädde. Kan inte serveras utan nötter.",
      price: "95",
      allergens: "Nötter, Mild chili, Mejeriprodukter"
    },
    {
      number: "44",
      name: "Crispy Touch",
      description: "Knapriga kycklingnuggets. Serveras med pommes frites och ketchup.",
      price: "79",
      allergens: "Gluten, Mild chili, Mejeriprodukter"
    },
    {
      number: "45",
      name: "Burger Heaven",
      description: "En saftig kycklingburgare. Serveras med pommes frites.",
      price: "99",
      allergens: "Gluten, Mild chili, Mejeriprodukter"
    },
    {
      number: "46",
      name: "Magic Chicken Skewers",
      description: "2 st thailändska kycklingspett. Serveras med jordnött sås och nudlar eller ris.",
      price: "99",
      allergens: "Gluten, Medium chili"
    },
    {
      number: "47",
      name: "Crunchies",
      description: "3 st thailändska kyckling marinerad och panerad i panko kycklingfilé. Serveras med sweetchili sås och nudlar eller ris.",
      price: "99",
      allergens: "Gluten, Mild chili"
    }
  ],
  burgers: [
    {
      number: "48",
      name: "Chicken Burger",
      description: "Kycklingkött marinerad och panerad i speciell mjölblandning friteras och serveras i en hamburgare med sås, sallad, ost och med pommes vid sidan.",
      price: "189",
      allergens: "Gluten, Medium chili, Mejeriprodukter"
    },
    {
      number: "50",
      name: "Pommes",
      description: "Gyllenstekta pommes frites.",
      price: "59",
      allergens: ""
    }
  ],
  dessert: [
    {
      name: "Mango Lassi",
      description: "En förtrollande dryck av mixad mango, mjölk, pistage, almond, yoghurt och en touch av kardemumma, blomblad och sötma.",
      price: "89"
    },
    {
      name: "Mango Sorbet",
      description: "En frisk och fruktig fryst efterrätt gjord av mixad mango, socker och citron.",
      price: "89"
    },
    {
      name: "Piggelin Sorbet",
      description: "En frisk och fruktig fryst efterrätt gjord av mixad vindruvor, sprite, socker och piggelin.",
      price: "89"
    },
    {
      name: "Twister Sorbet",
      description: "En frisk och fruktig fryst efterrätt gjord av mixade jordgubbar, ananas, Sprite, socker och Twister.",
      price: "89"
    },
    {
      name: "Friterad Glass",
      description: "En kula glass friterad till perfektion och serverad med valfri topping. En härlig kombination av varmt och kallt.",
      price: "105"
    },
    {
      name: "Krispiga Friterade Banan",
      description: "En smakrik rätt med bananskivor doppade i smet och friterade till perfektion.",
      price: "99"
    },
    {
      name: "Barn Glass",
      description: "Två kulor vaniljglass med strössel och ringlad chokladsås.",
      price: "79"
    },
    {
      name: "Chokladfondant Med Glass",
      description: "En krämig chokladkaka med smält chokladfyllning inuti. Serveras med en svalkande kula vaniljglass.",
      price: "99"
    },
    {
      name: "Stekt Ananas",
      description: "Gyllenbrun och karamelliserad ananas. Serveras med en svalkande kula vaniljglass.",
      price: "99"
    }
  ],
  mocktails: [
    {
      name: "Berry Burst",
      description: "Lime, jordgubb, blåbär, hallon, Sprite.",
      price: "80"
    },
    {
      name: "Berrylicious",
      description: "Jordgubb, mynta, Sprite.",
      price: "75"
    },
    {
      name: "Blåbär Mojito",
      description: "Blåbär, Sprite, mynta.",
      price: "80"
    },
    {
      name: "Dragon's Delight",
      description: "Dragon fruit, lime, Sprite.",
      price: "90"
    },
    {
      name: "Mango Punch",
      description: "Mango, apelsin, kokos.",
      price: "90"
    },
    {
      name: "Mint Fizz",
      description: "Sprite, lime, mynta, Piggelin.",
      price: "90"
    },
    {
      name: "Mojito",
      description: "Lime, Sprite, socker, mynta.",
      price: "75"
    },
    {
      name: "Pina Colada",
      description: "Ananasjuice, kokoskräm, kokos.",
      price: "90"
    },
    {
      name: "Tropical Paradise",
      description: "Mango, Jordgubb, lime, Sprite.",
      price: "90"
    },
    {
      name: "Vattenmelon Mojito",
      description: "Vattenmelon, Sprite, mynta.",
      price: "90"
    }
  ],
  beverages: [
    {
      name: "Mjölk",
      price: "15"
    },
    {
      name: "Läsk 33cl",
      price: "35"
    },
    {
      name: "Apelsin- eller Äpplejuice",
      price: "30"
    },
    {
      name: "Isvatten med mynta och citron",
      price: "15"
    }
  ]
};
